import cognitoUser from '@/api/cognito-user'
import user from '@/api/user'
import { Promise } from "es6-promise";
import { stat } from 'fs';

/**
 * initial state
 */
const state = {
  userId: '',
  email: '',
  languageId: 0,
  languageName: '',
  accessToken: '',
  loginExecuteStatus: '',
  userAttributes: [],
  signupExecuteData: [],
  userMeta: [],
}

/**
 * getters
 */
const getters = {
  userId: state => state.userId,
  email: state => state.email,
  languageId: state => state.languageId,
  languageName: state => state.languageName,
  accessToken: state => state.accessToken,
  userAttributes: state => state.userAttributes,
  loginExecuteStatus: state => state.loginExecuteStatus,
  signupExecuteData: state => state.signupExecuteData,
  userMeta: state => state.userMeta

}

/**
 * actions
 */
const actions = {

  initializeUser ({ commit }) {
    return new Promise((resolve, reject) => {
      cognitoUser.setUserAttributes()
      .then(attributes => {
        commit('SET_USER_ATTRIBUTES', attributes)
        commit('LOGIN_SUCCESS')
        return resolve()
      })
      .catch(() => {
        commit('LOGOUT_SUCCESS')
        return reject()
      })
    })
  },

  login ({ commit }, params) {
    commit('LOGIN_REQUEST')
    return new Promise((resolve, reject) => {

      cognitoUser.login(params)
        .then((res) => {
          commit('LOGIN_SUCCESS')
          cognitoUser.setUserAttributes()
            .then(attributes => {
              // console.log(attributes)
              commit('SET_USER_ATTRIBUTES', attributes)
            })
          return resolve(res)
        })
        .catch(error => {
          commit('LOGIN_ERROR', error)
          return reject(error)
        })
    })
  },

  signup ({ commit }, params) {
    return new Promise((resolve, reject) => {
      user.signup(params)
        .then(res => {
          commit('USER_SIGN_UP', params)
          return resolve(res)
        })
        .catch(error => {
          return reject(error)
        })
    })
  },  

  logout ({ commit }) {
    cognitoUser.logout()
      .then((res) => {
        commit('LOGOUT_SUCCESS')
        return resolve(res)
      }).catch((err) => {
        return reject(error)
      })
  },

  setLoginExecuteStatus({commit}, params){
    commit('SET_LOGIN_EXECUTE_STATUS', params)
  },
  switchingLanguage({commit}, params){
    commit('SET_USER_LANGUAGE', params)
  },

  setNewEmail: ({commit, state}, newValue) => {
    commit('SET_NEWEMAIL', newValue)
    return state.email
  },

  setUserMeta({commit}, params){
    commit('USER_META', params)
  },

  setUserAttributes({commit}, params){
    commit('SET_USER_ATTRIBUTES', params)
  }

}

/**
 * mutations
 */
const mutations = {
  USER_META(state, attribute){
    state.userMeta = attribute
  },

  SET_USER_ATTRIBUTES(state, attr){
    state.userAttributes = attr
  }, 
  
  SET_USER_LANGUAGE(state, attribute){
    state.languageName = attribute
  },

  LOGIN_REQUEST (state) {
    state.loginExecuteStatus = 'request'
  },

  LOGIN_SUCCESS (state) {
    state.loginExecuteStatus = 'success'
  },

  SET_LOGIN_EXECUTE_STATUS(state, message) {
    state.loginExecuteStatus = message
  },

  LOGIN_ERROR(state, message) {
    state.loginExecuteStatus = message
  },

  SET_USER_ATTRIBUTES(state, attributes) {
    state.userId = attributes.userId
    state.email = attributes.email
    state.languageId = attributes.languageId
    state.languageName = attributes.languageName
    state.accessToken = attributes.accessToken
  },

  SET_NEWEMAIL: (state, newValue) => {
    state.email = newValue
  },

  LOGOUT_SUCCESS(state) {
    state.loginExecuteStatus = ''
  },

  USER_SIGN_UP(state, params) {
    state.signupExecuteData = params
  },  

}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/user.js